/* import __COLOCATED_TEMPLATE__ from './service-details.hbs'; */
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './service-details.module.scss';

@classic
@classNames(styles.component)
export default class SiteDocumentsGoodFaithEstimateServiceDetails extends Component {}
